export class ConstantsTableCols { 
  static readonly DATASET_SELECTED: string = 'DATASET_SELECTED';
  static readonly INDIKATOR_BEZEICHNUNG: string = 'INDIKATOR_BEZEICHNUNG';
  static readonly INDIKATOR_INFO: string = 'INDIKATOR_INFO';
  static readonly QUELLE_INDIKATOR: string = 'QUELLE_INDIKATOR';
  static readonly ID_IND: string = 'ID_IND';
  static readonly DIMENSION: string = 'DIMENSION';
  static readonly DOWNLOAD: string = 'DOWNLOAD';
}
